export default "__VITE_ASSET__e27f8f74__"